import { snakeCase } from 'lodash-es';

const UPDATER_URL = 'https://www.updater.com';

const STANDARD_CATEGORIES = [
  {
    name: 'About Us',
    id: 'about_us',
    icon: 'heart',
    type: 'regular',
    links: [
      {
        code: 'about',
        name: 'About',
        href: `${UPDATER_URL}/about-us`,
        event: 'Footer About Us Link',
      },
      {
        code: 'team',
        name: 'Team',
        href: `${UPDATER_URL}/team`,
        event: 'Footer Team Link',
      },
      {
        code: 'jobs',
        name: 'Jobs',
        href: `${UPDATER_URL}/jobs`,
        event: 'Footer Jobs Link',
      },
      {
        code: 'press',
        name: 'Press',
        href: `${UPDATER_URL}/press`,
        event: 'Footer Press Link',
      },
    ],
  },
  {
    name: 'Resources',
    id: 'resources',
    icon: 'star',
    type: 'regular',
    links: [
      {
        code: 'blog',
        name: 'Blog',
        href: `${UPDATER_URL}/blog`,
        event: 'Footer Blog Link',
      },
      {
        code: 'moving_tips',
        name: 'Moving Tips & Tricks',
        href: `${UPDATER_URL}/moving-tips`,
        event: 'Footer Moving Tips Link',
      },
      {
        code: 'faqs',
        name: 'Support Center',
        href: `http://help.updater.com`,
        event: 'Footer FAQS Link',
      },
    ],
  },
  {
    name: 'Talk To Us',
    id: 'talk_to_us',
    icon: 'bullhorn',
    type: 'solid',
    links: [
      {
        code: 'contact_us',
        name: 'Contact Us',
        href: `${UPDATER_URL}/contact-us`,
        event: 'Footer Contact Us Link',
      },
    ],
    socialLinks: [
      {
        icon: 'facebook-f',
        name: 'Facebook',
        href: '//facebook.com/updater',
        event: 'Footer Facebook Link',
      },
      {
        icon: 'twitter',
        name: 'Twitter',
        href: '//twitter.com/updater',
        event: 'Footer Twitter Link',
      },
      {
        icon: 'linkedin-in',
        name: 'Linked In',
        href: '//linkedin.com/company/updater',
        event: 'Footer LinkedIn Link',
      },
    ],
  },
];

const STANDARD_LEGAL = [
  {
    href: `${UPDATER_URL}/terms`,
    text: 'Privacy',
    event: 'Footer Privacy Link',
  },
  {
    href: `${UPDATER_URL}/terms`,
    text: 'Terms',
    event: 'Footer Terms Link',
  },
];

const utilitiesCategories = ({ privacyPolicies = [] } = {}) => [
  {
    id: 'utilities_links',
    links: [
      ...privacyPolicies.map(({ title, url }) => ({
        code: snakeCase(title),
        name: title,
        href: url,
        event: `Footer ${title} Link`,
      })),
    ],
  },
];

export const CONFIG = data => {
  return {
    STANDARD: {
      categories: STANDARD_CATEGORIES,
      legal: STANDARD_LEGAL,
      madeWithLove: true,
      showCopywrite: true,
    },
    UTILITY: {
      categories: utilitiesCategories(data),
      disclaimer: data.disclaimer,
    },
  };
};
